<header class="ui-app-header">
  <div class="ui-app-header__left">
    <button class="ui-app-header__menu-btn" type="button" (click)="onMenuToggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <div class="ui-app-header__title-block">
      <h1 class="ui-app-header__title">{{ title }}</h1>
      <app-ui-breadcrumb [items]="breadcrumbs"></app-ui-breadcrumb>
    </div>
  </div>
  <div class="ui-app-header__right">
    <app-ui-app-badge [label]="appName"></app-ui-app-badge>
    <app-ui-user-menu
      [userName]="user.userName"
      [companyName]="user.companyName"
      [initials]="user.initials"
      (logout)="onLogout()">
    </app-ui-user-menu>
  </div>
</header>
